import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import PatientLoader from "../../../../common/PatientLoader";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import { pinnedContentLabelsColors } from "../../../../../constants/constants";

ChartJS.register(CategoryScale, ArcElement, Title, Tooltip, Legend);
const PinnedPieChart = ({
  title,
  patientPinnedContent,
  pinnedContentLoading,
}) => {
  const [formattedData, setFormattedData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [labels, setLabels] = useState([]);
  useEffect(() => {
    if (
      !pinnedContentLoading &&
      patientPinnedContent &&
      patientPinnedContent?.length > 0
    ) {
      const tempData = {};
      patientPinnedContent.forEach((item) => {
        if (item?.classification?.Name in tempData) {
          tempData[item?.classification?.Name] += 1;
        } else {
          tempData[item?.classification?.Name] = 1;
        }
      });
      setFormattedData(tempData);
      const tempLabels = Object.keys(tempData);
      setLabels(tempLabels);
      const tempValues = Object.values(tempData);
      setFinalData(tempValues);
    }
  }, [pinnedContentLoading, patientPinnedContent]);

  const data = {
    labels: labels,
    datasets: [
      {
        label: title,
        data: finalData,
        backgroundColor: Object.values(pinnedContentLabelsColors),
        hoverOffset: 4,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          useBorderRadius: true,
          borderRadius: 100,
          pointStyle: "circle",
          family: "'DM Sans'",
        },
        position: "left",
      },
      title: {
        display: true,
        fontSize: 40,
        family: "'DM Sans'",
        text: title,
        align: "start",
      },
    },
  };
  
  return (
    <CardLayout
      className="col-sm-12 col-md-6 col-lg-6 p-5"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      {pinnedContentLoading ? (
        <PatientLoader />
      ) : (
        <Doughnut options={options} data={data} width={500} height={250} />
      )}
    </CardLayout>
  );
};

export default PinnedPieChart;
